(function () {
    'use strict';

    angular.module("imApp").factory("furnitureFabricsColorService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 2120,
                    parameters: parms || {}
                });
            },
            listFurnitureFabricsLights: function (parms) {
                return $ihttp.post({
                    method: 2121,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2122,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
